const setSession = (accessToken) => {

  if (accessToken) {
      localStorage?.setItem("accessToken", accessToken);
    } else {
      localStorage?.clear("accessToken");
    }
    
  };

export default setSession;
